import React, { Component } from 'react';
import he from 'he';
import { navigate } from 'gatsby';

class TagSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  handleChange = (event) => {
    navigate(event.target.value);
  };

  render() {
    const tagOptions = [];
    for (const [index, value] of this.props.tags.entries()) {
      tagOptions.push({
        value: `/blog/tag/${value.node.slug}`,
        label: `${he.decode(value.node.name)} (${value.node.count})`
      });
    }
    //const defaultTag = find(tagOptions, (tag) => { return tag.label.includes(this.props.currentTag); });
    return (
      <>
        <select className="left-sidebar-links-dropdown select-style-1" options={tagOptions}
          onChange={this.handleChange}>
          {/* <option key={'everything'} value="/blog/"> {"Everything " + `(${this.props.totalPosts})`} </option> */}
          {tagOptions.map((tag, index) => {
              return <option key={index} value={tag.value + '/'}> {tag.label} </option>;
          })}
        </select>
      </>
    );
  }
}

export default TagSelect;
